const allshows = [
    {
      venue: "Plaza Midwood",
      city: "Charlotte, NC",
      link: "https://www.sofarsounds.com/events/52360",
      date: "2023-11-03T19:30:00",
    },
  ];

  export default allshows;